import { api } from "@/services";
import qs from "qs";

async function useAsyncTiresData(slug: string = null) {
  let Data: any = null;
  let Error: string = null;

  const Controller = new AbortController();

  const MakeRequest = async () => {
    try {
      const resp = await api.get(`/Contents/GetBySlug`, {
        signal: Controller.signal,
        params: {
          slugs: slug ?? ["menu-modelos-linglong"]
        },
        paramsSerializer: (params) => {
          return qs.stringify(params, { arrayFormat: "repeat" });
        }
      });
      if (resp.data && resp.data.length > 0) {
        Data = resp.data;
      } else {
        Error = "Nenhum conteúdo encontrado";
      }
    } catch (Err) {
      Error = Err.message;
    }
  };

  await MakeRequest();

  Controller.abort();

  return [Data, Error];
}

export { useAsyncTiresData };
